<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-card>
            <template #heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <va-field source="id"></va-field>
                  <va-field source="name"></va-field>
                  <va-field source="realms" type="array" label="Market"></va-field>
                </v-col>
                <v-col>
                  <template v-if="item">
                    <va-field source="createdAt" type="date" class="mt-0 pt-0">
                      {{ new Date(item.createdAt).toLocaleDateString('en-CA') }}
                    </va-field>
                    <va-field source="lastUpdatedAt" type="date">
                      {{ new Date(item.lastUpdatedAt).toLocaleDateString('en-CA') }}
                    </va-field>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
          <base-material-card icon="mdi-book" title="Books in series">
            <va-list
              resource="books"
              disable-query-string
              disable-create
              disable-global-search
              disable-export
              disable-pagination
              :items-per-page="1000"
              :filter="{
                'serie.id': item.id,
              }"
            >
              <va-data-table :fields="fields" disable-select disable-edit disable-clone disable-actions></va-data-table>
            </va-list>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { source: 'id', link: 'edit', label: 'ID' },
        { source: 'isbn', label: 'ISBN' },
        { source: 'title', sortable: true },
        { source: 'serie.readingOrder', sortable: true },
      ],
    };
  },
};
</script>
